var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"contextStyle":_vm.contextStyle}}),(( _vm.$route.params.id !== undefined && parseInt( _vm.$route.params.id ) >= 0 ))?_c('UsersForm'):_c('v-card',{staticClass:"ma-4",staticStyle:{"background-color":"transparent !important"}},[_c('UsersList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }